import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { CloudApiService } from './services/cloud-api.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
    const router = inject(Router);
    const cloudApi = inject(CloudApiService);

    return next(req).pipe(
        catchError((error) => {
            // If we get a 401 Unauthorized response, it means the token has expired or is invalid
            if (error.status === 401) {
                // Don't redirect if already on login/auth pages or if this is a login/refresh request
                const currentUrl = router.url;
                const isAuthEndpoint = req.url.includes('/auth/login') ||
                    req.url.includes('/auth/refresh') ||
                    req.url.includes('/auth/logout');
                const isAuthPage = currentUrl.includes('/auth/login') ||
                    currentUrl.includes('/reset-password') ||
                    currentUrl.includes('/accept-invite');

                if (!isAuthEndpoint && !isAuthPage) {
                    // Clear the auth state
                    cloudApi.logout();

                    // Navigate to login page with return URL
                    router.navigate(['/auth/login'], {
                        queryParams: { returnUrl: currentUrl }
                    });
                }
            }

            return throwError(() => error);
        })
    );
};
